// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import * as React from 'react';
import {useCallback} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';

import {urlPrefixed} from '../../../config';
import {BoundingBoxes} from '../../ImageCard/BoundingBoxes';
import * as S from '../../ImageCard/ImageCard.styles';
import {TileMediaSpec} from '../../MediaCard';
import {useSingleRunLink} from '../../MultiRunWorkspace/SingleRunMode';
import {getTileMediaLabels} from '../tiles/getTileMediaSpecs';
import {MediaBrowserModalProps} from './types';

type StepLabelProps = {
  tileMediaSpec: TileMediaSpec;
};
const StepLabel = ({tileMediaSpec}: StepLabelProps) => {
  const {sliderLabel, stepLabel, indexLabel} = getTileMediaLabels({
    step: tileMediaSpec.mediaStep,
    index: tileMediaSpec.mediaIndex,
    mediaSliderKey: tileMediaSpec.mediaSliderKey,
    mediaSliderKeyValue: tileMediaSpec.mediaSliderKeyValue,
  });
  const heading = sliderLabel ?? stepLabel;
  const subheading = indexLabel;
  return (
    <div className="flex w-full items-center justify-center">
      <div className="font-semibold">
        <div className="flex flex-col items-center justify-center">
          <div className="font-semibold">{heading}</div>
          {subheading && <div className="text-xs">{subheading}</div>}
        </div>
      </div>
    </div>
  );
};

export const MediaBrowserModal: React.FC<MediaBrowserModalProps> = ({
  isOpen,
  modalData,
  onClose,
}) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const titleLinkToRun = useSingleRunLink(modalData?.runSignature);

  if (!isOpen || !modalData) {
    return null;
  }

  const {
    mediaPanelRef,
    tileMediaSpec,
    labels,
    imageURL,
    originalPixelOffset,
    fullScreenTitle,
    boundingBoxData,
    mediaKey,
    runSignature,
    mediaSize,
    controls,
  } = modalData;

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      size="fullscreen"
      content={
        <TailwindContents>
          <div className="flex h-[95vh] flex-col p-12" data-test="media-modal">
            <div className="flex w-full items-center justify-center">
              {labels?.includes('run') ? (
                <Button
                  variant="ghost"
                  onClick={() => window.open(urlPrefixed(titleLinkToRun))}>
                  <>{fullScreenTitle}</>
                </Button>
              ) : (
                <div className="font-semibold">{fullScreenTitle}</div>
              )}
            </div>
            <S.FullscreenWrapper>
              <S.FullscreenImageContainer>
                <S.FullscreenImage
                  style={{marginLeft: -originalPixelOffset}}
                  alt="card"
                  src={imageURL}
                />
                {boundingBoxData && boundingBoxData.length > 0 && (
                  <S.FullscreenBoundingBoxContainer>
                    {boundingBoxData.map(({key, wbFile, classLabels}) => (
                      <BoundingBoxes
                        style={{position: 'absolute', top: 0}}
                        key={key}
                        mediaKey={mediaKey}
                        boxStyle={
                          controls?.boundingBoxControl?.styles?.[mediaKey]?.[
                            key
                          ]
                        }
                        boxToggles={
                          controls?.boundingBoxControl?.toggles?.[mediaKey]?.[
                            key
                          ]
                        }
                        boxSliders={controls?.boundingBoxControl?.sliders}
                        boxKey={key}
                        classLabels={classLabels}
                        runSignature={runSignature}
                        boxFileInfo={wbFile}
                        cardSize={mediaSize}
                        mediaSize={mediaSize}
                        mediaPanelRef={mediaPanelRef}
                      />
                    ))}
                  </S.FullscreenBoundingBoxContainer>
                )}
              </S.FullscreenImageContainer>
            </S.FullscreenWrapper>
            <StepLabel tileMediaSpec={tileMediaSpec} />
          </div>
        </TailwindContents>
      }
    />
  );
};

export default MediaBrowserModal;
